export enum LocationKind {
    Plot = 0,
    Home = 1,
    Warp = 2,
    ClanHome = 3,
    Custom = 4
}

export interface GameLocation {
    kind: LocationKind;
    name: string;
}

export const LOCATION_PREFIXES: Record<LocationKind, string> = {
    [LocationKind.Plot]: '/p h',
    [LocationKind.Home]: '/home',
    [LocationKind.Warp]: '/warp',
    [LocationKind.ClanHome]: '/clan home',
    [LocationKind.Custom]: ''
};

export const LOCATION_KIND_LABELS: Record<LocationKind, string> = {
    [LocationKind.Plot]: 'PLOT_HOME',
    [LocationKind.Home]: 'CONFIG_HOME',
    [LocationKind.Warp]: 'WARP',
    [LocationKind.ClanHome]: 'CLAN_HOME',
    [LocationKind.Custom]: 'LOCATION_CUSTOM'
};

export const LOCATION_KINDS: LocationKind[] = [
    LocationKind.Plot,
    LocationKind.Home,
    LocationKind.Warp,
    LocationKind.ClanHome,
    LocationKind.Custom
];

// Longest prefix first, so adding a shorter one later cannot shadow a longer one already here.
const PARSE_ORDER: LocationKind[] = [
    LocationKind.ClanHome,
    LocationKind.Warp,
    LocationKind.Home,
    LocationKind.Plot
];

// Mirrors Vektor.Griefergames/GameLocation.cs. Null for an unset location, which every consumer
// reads as "no travel configured".
export function parseLocation(text: string | null | undefined): GameLocation | null {
    if (!text || !text.trim()) return null;

    const line = text.trim();

    // A location without a leading slash is a bare plot name, which is what every location held
    // before the kinds existed.
    if (!line.startsWith('/')) return { kind: LocationKind.Plot, name: line };

    for (const kind of PARSE_ORDER) {
        const prefix = LOCATION_PREFIXES[kind];
        if (!line.toLowerCase().startsWith(prefix + ' ')) continue;
        const name = line.substring(prefix.length).trim();
        if (!name) break;
        return { kind, name };
    }

    return { kind: LocationKind.Custom, name: line };
}

export function formatLocation(location: GameLocation): string {
    if (location.kind === LocationKind.Custom) return location.name;
    return `${LOCATION_PREFIXES[location.kind]} ${location.name}`;
}
